import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, ButtonGroup, Row, Col, Form } from "react-bootstrap";
import api from "../api/api";
import swal from "sweetalert";
import "../styles/management-pages.css";

function FarmList({ onFarmDeleted }) {
  const [classMsg, setCmsg] = useState("");
  const [farmList, setFarmList] = useState([]);
  const [editedFarm, setEditedFarm] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [displayMsg, setDispMsg] = useState("hide");
  const [iconMsg, setIconMsg] = useState("info");
  const [msgServer, setMsg] = useState("");
  const [country, setCountry] = useState("");
  const [cities, setCities] = useState("");
  const [allCities, setAllCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const { t, i18n } = useTranslation();
  const [deletedFarms, setDeletedFarms] = useState([]);
  const [showDeletedModal, setShowDeletedModal] = useState(false);

  const fetchFarms = async () => {
    try {
      const response = await api.get("/farm/farms");
      setFarmList(response.data.farms);
    } catch (err) {
      console.error("Failed to fetch farms", err);
    } finally {
      setLoading(false);
    }
  };
  // Fetch deleted farms
  const fetchDeletedFarms = async () => {
    try {
      let url = "/farm/deleted-farms";

      // Assuming you stored the user info as JSON in localStorage
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.id; // get the id safely

      // You could send the user ID as a query param if your backend needs it
      const res = await api.get(url, {
        params: { userId }, // optional if backend uses req.user instead
      });

      setDeletedFarms(res.data.deletedFarms || []);
    } catch (err) {
      console.error("Failed to fetch deleted farms", err);
    }
  };

  // Restore farm
  const handleRestoreFarm = async (farm_uid) => {
    try {
      const res = await api.post("/farm/restore-farm", { farm_uid });
      if (res.data.type === "success") {
        swal({ title: t("farm_restored_success"), icon: "success" });
        fetchDeletedFarms();
        fetchFarms();
      } else {
        swal({ title: t("restore_failed"), icon: "error" });
      }
    } catch (err) {
      swal({ title: t("restore_error"), icon: "error" });
    }
  };
  useEffect(() => {
    fetchFarms();
    const getCountries = async () => {
      await api.get("/countries/get-countries").then((res) => {
        const countries = res.data.Countries;
        setCountries(countries);
      });
    };
    const getCities = async () => {
      await api.get("/cities/get-cities").then((res) => {
        const cities = res.data.Cities;
        setAllCities(cities);
      });
    };

    fetchFarms();
    getCountries();
    getCities();
  }, []);

  const handleCountryPick = (e) => {
    e.preventDefault();
    const country = countries.find((country) => country.iso === e.target.value);
    let Cities = [];
    if (country) {
      allCities.map((city) => {
        if (city.iso === country.iso) {
          Cities.push({
            city: city.city,
            id: city.id,
            lat: city.lat,
            lon: city.lon,
          });
        }
      });

      setCountry(country.iso);
      setCities(Cities);
    }
  };
  const handleEditFarm = async () => {
    try {
      const payload = {
        name: editedFarm.name,
        name_group: editedFarm.name_group,
        city_id: editedFarm.city_id,
        user_uid: editedFarm.user?.uid || editedFarm.user_uid,
        farm_uid: editedFarm.uid,
      };

      if (!payload.user_uid) {
        throw new Error("Missing user_uid in editedFarm");
      }

      const response = await api.post("/farm/edit-farm", payload);
      let updatedFarm = response.data.farm;

      const matchedCity = allCities.find(
        (city) => city.id == updatedFarm.city_id
      );
      if (matchedCity) {
        updatedFarm.city = matchedCity;
      }

      updatedFarm.user = editedFarm.user || { uid: editedFarm.user_uid };

      setFarmList((prev) =>
        prev.map((f) => (f.uid === updatedFarm.uid ? updatedFarm : f))
      );

      setToggle(false);
      setMsg(t("farm_updated_successfully"));
      setIconMsg("check");
      setCmsg("success");
      setDispMsg("show");
    } catch (error) {
      console.error("Failed to edit farm:", error);
      setMsg(t("error_updating_farm"));
      setIconMsg("times");
      setCmsg("danger");
      setDispMsg("show");
    }
  };
  const handleDeleteFarm = async (farm_uid) => {
    try {
      const res = await api.delete("/farm/delete-farm", { data: { farm_uid } });

      if (res.data.type && res.data.type == "danger") {
        swal({
          title: `${t("cannot_delete")}`,
          icon: "warning",
        });
        return;
      }

      // ✅ Refresh farms in FarmList
      await fetchFarms();

      // ✅ Refresh all related data in parent component

      await onFarmDeleted();

      setMsg(t("farm_deleted_successfully"));
      setIconMsg("check");
      setCmsg("success");
      setDispMsg("show");
    } catch (error) {
      console.error("Failed to delete farm:", error);
      setMsg(t("error_deleting_farm"));
      setIconMsg("times");
      setCmsg("danger");
      setDispMsg("show");
    }
  };
  const confirmDelete = (farm_uid) => {
    swal({
      title: `${t("are_you_sure")}`,
      text: `${t("confirm_delete")}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((Delete) => {
        if (Delete) {
          handleDeleteFarm(farm_uid);
          swal(`${t("delete_success_farm")}`, {
            icon: "success",
          });
        }
      })
      .catch((error) => {
        swal({
          title: `${t("cannot_delete")}`,
          icon: "error",
          text: t("Error"),
        });
      });
  };

  return (
    <>
      {displayMsg === "show" && (
        <div className={`mb-3 alert alert-${classMsg} fade show`}>
          <i className={`fa fa-${iconMsg} mx-2`}></i> {t(msgServer)}
        </div>
      )}
      <div className="mb-3">
        <Button
          variant="secondary"
          onClick={() => {
            setShowDeletedModal(true);
            fetchDeletedFarms();
          }}
        >
          <i className="fa fa-trash-restore mx-2"></i>
          {t("deleted_farms")}
          {deletedFarms.length > 0 && (
            <span className="badge bg-danger ms-2">{deletedFarms.length}</span>
          )}
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table className="table mb-4 text-center table-bordered table-responsive-lg">
          <thead className="bg-light">
            <tr>
              <th scope="col" className="border-0">
                {t("name")}
              </th>
              <th scope="col" className="border-0">
                {t("name_group")}
              </th>
              <th scope="col" className="border-0">
                {t("city")}
              </th>
              <th scope="col" className="border-0"></th>
            </tr>
          </thead>
          <tbody>
            {farmList?.map((item, indx) => {
              return (
                <tr>
                  <td>{item.name}</td>
                  <td>{item.name_group ? item.name_group : "-"}</td>
                  <td>{item.city && item.city.city ? item.city.city : "-"}</td>

                  <td>
                    <ButtonGroup size="sm" className="mr-2 gap-2">
                      <Button
                        variant="info"
                        onClick={() => {
                          setEditedFarm(item);
                          const selectedIso = item.city?.iso || "";
                          setCountry(selectedIso);
                          const filteredCities = allCities.filter(
                            (city) => city.iso === selectedIso
                          );
                          setCities(filteredCities);
                          setToggle(true);
                        }}
                      >
                        <i className="fas fa-pen" aria-hidden="true" />
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => confirmDelete(item.uid)}
                      >
                        <i className="fas fa-trash" aria-hidden="true" />
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Modal
        size="lg"
        dialogClassName="entity-edit-modal"
        show={toggle}
        onHide={() => setToggle(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="entity-edit-header">
          <h6 className="m-0">{t("edit_farm")}</h6>{" "}
          <div className="entity-edit-actions">
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-success"
              onClick={handleEditFarm}
            >
              {t("save")}
              <i className="fas fa-check mx-2" aria-hidden="true" />
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => setToggle(false)}
            >
              {t("cancel")}
              <i className="fas fa-times mx-2" aria-hidden="true" />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form className="entity-edit-form">
            <Row form className="gap-2 justify-content-between">
              <Form.Group as={Col} md="4">
                <Form.Label>{t("name_farm")} *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("name_farm")}
                  value={editedFarm.name || ""}
                  onChange={(e) =>
                    setEditedFarm({ ...editedFarm, name: e.target.value })
                  }
                  style={{ height: "40px" }}
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>{t("group_name")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("group_name")}
                  value={editedFarm.name_group}
                  onChange={(e) =>
                    setEditedFarm({ ...editedFarm, name_group: e.target.value })
                  }
                  style={{ height: "40px" }}
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label>{t("select_country")} *</Form.Label>

                <Form.Select
                  onChange={handleCountryPick}
                  value={country}
                  required
                  style={{ height: "40px" }}
                >
                  <option value="">{t("select_country")}</option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.iso}>
                      {country.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            <Form.Group
              as={Col}
              md="6"
              controlId="validationCustom03"
              className="mt-2"
            >
              <Form.Label>{t("select_city")} *</Form.Label>
              <Form.Select
                value={editedFarm.city_id}
                onChange={(e) =>
                  setEditedFarm({ ...editedFarm, city_id: e.target.value })
                }
                required
                style={{ height: "40px" }}
              >
                <option value="">{t("select_city")}</option>
                {cities &&
                  cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.city}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={showDeletedModal}
        onHide={() => setShowDeletedModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("deleted_farms")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deletedFarms.length === 0 ? (
            <div className="text-center py-4">
              <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
              <p className="text-muted">{t("no_deleted_farms")}</p>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table text-center table-bordered">
                <thead className="bg-light">
                  <tr>
                    <th>{t("name")}</th>
                    <th>{t("name_group")}</th>
                    <th>{t("city")}</th>
                    <th>{t("deleted_at")}</th>
                    <th>{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedFarms.map((farm) => (
                    <tr key={farm.uid}>
                      <td>{farm.name}</td>
                      <td>{farm.name_group || "-"}</td>
                      <td>{farm.city?.city || "-"}</td>
                      <td>
                        {farm.deleted_at
                          ? new Date(farm.deleted_at).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td>
                        <ButtonGroup size="sm">
                          <Button
                            variant="success"
                            onClick={() => handleRestoreFarm(farm.uid)}
                          >
                            <i className="fa fa-undo"></i> {t("restore")}
                          </Button>
                          {/* <Button
                      variant="danger"
                      onClick={() => handlePermanentDeleteFarm(farm.uid)}
                    >
                      <i className="fa fa-trash"></i>
                    </Button> */}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeletedModal(false)}
          >
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FarmList;
